import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { authGuardModule } from './modules/authGuard';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [catalogPlugin, navModule, authGuardModule, signInModule],
});
